import {TabWrapper, OrdersBtn, TabButtonContainer, OrdersIcon} from "../../styles/MainOtcStyle"
import Text from "../../utils/Text"
import OtcTabButton from "./OtcTabButton";
import {DText} from "../../styles/CommonStyles";
import {HOME} from "../../constants/urls";

const OtcTabContainer = ({activeTab, onTabButtonClicked}) => {


    const goToOrderPage = () => {
        window.location.href = HOME + "user/otc-history"
    }

    return (
        <TabWrapper>
            <TabButtonContainer>
                <OtcTabButton
                    onTabButtonClicked={() => onTabButtonClicked("market")}
                    text="otc-market"
                    active={activeTab === "market"}
                />
                {/*<OtcTabButton*/}
                {/*    onTabButtonClicked={() => onTabButtonClicked("limit")}*/}
                {/*    text="otc-limit"*/}
                {/*    active={activeTab === "limit"}*/}
                {/*/>*/}
            </TabButtonContainer>
            <OrdersBtn onClick={goToOrderPage}>
                <OrdersIcon size={18} />
                <DText>
                    <Text tid="orders" />
                </DText>
            </OrdersBtn>
        </TabWrapper>
    )
}


export default OtcTabContainer;
